/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Customizerole2Inputs */

const en_usermanagement_permissions_customizerole2 = /** @type {(inputs: Usermanagement_Permissions_Customizerole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customize role`)
};

/**
* | output |
* | --- |
* | "Customize role" |
*
* @param {Usermanagement_Permissions_Customizerole2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_customizerole2 = /** @type {((inputs?: Usermanagement_Permissions_Customizerole2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Customizerole2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_customizerole2(inputs)
});
export { usermanagement_permissions_customizerole2 as "userManagement_permissions_customizeRole" }